export default {"src":"/_next/static/media/shiitakemushrooms.5029fd52.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};